import SIMPLE_DATE_RANGE from "../../util/simple-date-range";

// TODO: get rid of this file, put all non-shared types and functions under their card folder

export type ActivityCount = { count: number; date: Date };

export const SIMPLE_DATE_RANGE_LABELS = SIMPLE_DATE_RANGE.map(({ label }) => ({
  label,
  value: label,
}));
